module.exports = __webpack_public_path__ + "img/exam (4).5bdb57d4.jpeg";